export const CoreProjectController = {
    index(): void {},
    show(): void {},
};
